$(function () {

    function getScreenEMs() {
        return $(window).width() / parseFloat($("body").css("font-size"));
    }


    //fixed navigation
    window.onscroll = changePos;

    function changePos() {
        var header = document.getElementById("navbar");
        if (window.pageYOffset > 70) {
            header.style.position = "fixed";
            header.style.top = "0";
        } else {
            header.style.position = "";
            header.style.top = "";
        }
    }

    // Set focus on skip link click
    $('.skip-link').on('click', function () {
        var skipTo = $("#" + this.href.split('#')[1]);
        skipTo.attr('tabindex', '0');
        skipTo.focus();
    });

    $('#mbl-menu-icon').on('click', function () {
        $(this).toggleClass('open');
        $('nav ul.open').removeClass('open');
        return false;
    });


    $('#main-nav>li>a').on('click', function (e) {
        if (getScreenEMs() <= 48 && $(this).attr("aria-haspopup")) {
            e.preventDefault();
            if (!dropdownShouldBeActive()) {
                $(this).next().addClass("open");
            }
        }
    });
    $('#search-btn').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $("#search-dropdown").fadeToggle(300);
    });


    $('.mbl-back').on('click', function (e) {
        e.preventDefault();
        $('nav ul.open').removeClass('open');
    });

    $('.filter-bar>button').on('click', function () {
        $('.filter-bar>button, .filter-bar>form').toggleClass('active');
    });

    $('form#search-dropdown').on('submit', function (e) {
        if ($("input[name='jobsearch_selector']:checked").val() == 'j') {
            e.preventDefault();
            //var njLink = "https://careers.hersheyjobs.com/?keyword="+$("input[name='q']").val();
            var njLink = "https://hersheypa.rec.pro.ukg.net/HER1020HERS/JobBoard/035cdc57-c54b-48c9-8c4d-f30e022675e5/?o=relevance&q=" + $("input[name='q']").val();
            window.location.href = njLink;
            exit();
        }
    });


    var owlHero = $('.owl-carousel');
    owlHero.on('initialized.owl.carousel', function (e) {
        $('.owl-dots').insertAfter('.owl-prev');
        setTimeout(() => {
            //if ($(window).width() >= 768) {
            $('.owl-controls').css({ 'top': $(e.target).find(".owl-item").eq(e.item.index).find(".hero-txt").position().top });
            /*} else{
                $('.owl-controls').css({ 'top' : '3%' });
            }*/
            $('.owl-controls').animate({ opacity: 1 }, 400);
        }, 1000);
    });
    owlHero.owlCarousel({
        loop: true,
        nav: true,
        dots: true,
        items: 1,
        navText: ['<svg><title>previous photo</title><path d="M7.429,0.428c0.571-0.571,1.429-0.571,2,0C10,1,10,1.857,9.429,2.429L3.214,8.571l6.357,6c0.571,0.571,0.571,1.429,0,2c-0.572,0.571-1.429,0.571-2,0L0.714,10C0.714,10,0,9.242,0,8.571s0.714-1.429,0.714-1.429L7.429,0.428z"/></svg>', '<svg><title>next photo</title><path d="M2.571,0.428c-0.571-0.571-1.429-0.571-2,0C0,1,0,1.857,0.571,2.429l6.214,6.143l-6.357,6c-0.571,0.571-0.571,1.429,0,2c0.572,0.571,1.429,0.571,2,0L9.286,10C9.286,10,10,9.242,10,8.571S9.286,7.143,9.286,7.143L2.571,0.428z"/></svg>']
    });
    owlHero.on('changed.owl.carousel resized.owl.carousel', function (e) {
        //if ($(window).width() >= 768) {
        $('.owl-controls').animate({ 'top': $(e.target).find(".owl-item").eq(e.item.index).find(".hero-txt").position().top }, 400);
        /*} else{
            $('.owl-controls').css({ 'top' : '3%' });
        }*/
    });

    var owlProperties = $('.owl-carousel-properties');
    owlProperties.owlCarousel({
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        navText: ['<span><svg><title>previous photo</title><path d="M7.429,0.428c0.571-0.571,1.429-0.571,2,0C10,1,10,1.857,9.429,2.429L3.214,8.571l6.357,6c0.571,0.571,0.571,1.429,0,2c-0.572,0.571-1.429,0.571-2,0L0.714,10C0.714,10,0,9.242,0,8.571s0.714-1.429,0.714-1.429L7.429,0.428z"/></svg></span>', '<span><svg><title>next photo</title><path d="M2.571,0.428c-0.571-0.571-1.429-0.571-2,0C0,1,0,1.857,0.571,2.429l6.214,6.143l-6.357,6c-0.571,0.571-0.571,1.429,0,2c0.572,0.571,1.429,0.571,2,0L9.286,10C9.286,10,10,9.242,10,8.571S9.286,7.143,9.286,7.143L2.571,0.428z"/></svg></span>'],
        responsive: {
            0: {
                stagePadding: 30,
                items: 2
            },
            600: {
                stagePadding: 30,
                items: 3
            },
            960: {
                stagePadding: 50,
                items: 5
            },
            1200: {
                stagePadding: 60,
                items: 6
            },
            1600: {
                stagePadding: 80,
                items: 6
            }
        }
    });
    owlProperties.on('wheel', '.owl-stage', function (e) {
        if (e.originalEvent.deltaY > 0) {
            owlProperties.trigger('next.owl.carousel');
        } else {
            owlProperties.trigger('prev.owl.carousel');
        }
        e.preventDefault();
    });
    owlProperties.on('changed.owl.carousel', function (e) {
        var index = e.item.index;

        if (index == 0) {
            $(e.target).find('.owl-prev').addClass('disabled');
        }
        else {
            $(e.target).find('.owl-prev').removeClass('disabled');
        }

        if (index == e.item.count - 1) {
            $(e.target).find('.owl-next').addClass('disabled');
        }
        else {
            $(e.target).find('.owl-next').removeClass('disabled');
        }
    });
    var $el = $('#hero');
    var heroBottom, propertycarousel_imgH;
    /*owlProperties.on('initialized.owl.carousel resized.owl.carousel', function(e) {

    });*/
    if ($('#property-carousel').length) {
        $(window).on('load resize scroll', function () {
            heroBottom = $el.position().top + $el.height();
            propertycarousel_imgH = $('#property-carousel img').height();

            /*	if( $(window).scrollTop() + $(window).height() > heroBottom){
                    $('.controls').removeAttr('style');
                }
                else{
                    $('.controls').css({
                        'position' : 'fixed'
                    });
                }*/
            if (($(window).scrollTop() + $(window).height() > heroBottom + $('#property-carousel').outerHeight(true) - (propertycarousel_imgH - 15)) || (getScreenEMs() <= 48)) {
                $('#property-carousel').removeAttr('style');
                $('#hero').removeAttr('style');
            }
            else {
                $('#property-carousel').css({
                    'position': 'fixed',
                    'bottom': -(propertycarousel_imgH + 15),
                    'margin-bottom': '0'
                });
                if ($('#property-carousel').length) {
                    $('#hero').css({
                        'margin-bottom': '10%'
                    });
                }
            }
        });
    }
});